// Store callbacks to call when script loads
const pendingCallbacks: (() => void)[] = [];

const GOOGLE_MAPS_SCRIPT_ID = 'google-maps-script';

const executeCallbacks = () => {
  pendingCallbacks.forEach(callback => callback());
  pendingCallbacks.length = 0;
};

export const loadGoogleMapsScript = (callback: () => void): void => {
  // If already loaded, call immediately
  if (window.google?.maps && window.google.maps.marker) {
    callback();
    return;
  }

  // Add callback to pending list
  pendingCallbacks.push(callback);

  // If script is already being loaded, wait for it
  if (document.getElementById(GOOGLE_MAPS_SCRIPT_ID)) {
    // Check if script has loaded but callbacks haven't been called yet
    const checkInterval = setInterval(() => {
      if (window.google?.maps && window.google.maps.marker) {
        clearInterval(checkInterval);
        executeCallbacks();
      }
    }, 100);
    
    // Stop checking after 10 seconds
    setTimeout(() => clearInterval(checkInterval), 10000);
    return;
  }

  // Create and load script
  const scriptElement = document.createElement('script');
  scriptElement.id = GOOGLE_MAPS_SCRIPT_ID;
  scriptElement.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCPZ_gY1GPpyMsXyGmCVwCAUbhsheU6wZQ&libraries=marker&v=beta&map_ids=DEMO_MAP_ID`;
  scriptElement.defer = true;

  // Copy nonce from an existing script if available (for CSP)
  const existingScript = document.querySelector('script[nonce]') as HTMLScriptElement;
  if (existingScript?.nonce) {
    scriptElement.nonce = existingScript.nonce;
  }

  scriptElement.onload = () => {
    // Wait a bit for Google Maps to fully initialize
    const checkReady = setInterval(() => {
      if (window.google && window.google.maps && window.google.maps.marker) {
        clearInterval(checkReady);
        executeCallbacks();
      }
    }, 50);
    
    // Fallback: execute callbacks after 2 seconds even if marker library isn't ready
    setTimeout(() => {
      clearInterval(checkReady);
      if (window.google?.maps) {
        executeCallbacks();
      }
    }, 2000);
  };

  scriptElement.onerror = () => {
    if (document.getElementById(GOOGLE_MAPS_SCRIPT_ID)) {
      document.getElementById(GOOGLE_MAPS_SCRIPT_ID)?.remove();
    }
    // Clear pending callbacks on error
    pendingCallbacks.length = 0;
  };

  document.head.appendChild(scriptElement);
};

